import cn from 'classnames';
import { UseRefinementListProps, useRefinementList } from 'react-instantsearch';

import { colours } from '@components/algolia/SearchResults/Sidebar/ColourRefinement/utils';

import swatchStyles from '../../ColourPicker/ColourSwatch/ColourSwatch.module.scss';
import styles from './ColourRefinement.module.scss';

export type ColourRefinementProps = UseRefinementListProps & {
  locale?: string;
};

const ColourRefinement = (props: ColourRefinementProps) => {
  const { locale, ...refinementListProps } = props;
  const { items, refine } = useRefinementList({
    ...refinementListProps,
    sortBy: ['isRefined'],
    limit: 100,
    operator: 'or',
  });

  const formatNumber = (count: number) =>
    new Intl.NumberFormat(locale ?? 'en').format(count);

  const swatchName = (value: string, fallback: string) =>
    locale === 'fr' ? colours[value]?.frenchSwatchName ?? fallback : fallback;

  return (
    <ul className={styles.list}>
      {items.map((item) => {
        const name = swatchName(item.value, item.label);
        const rawColour = colours[item.value]?.colour;
        const fill =
          rawColour && !rawColour.includes('gradient') ? rawColour : undefined;
        const isNoData = !fill;
        return (
          <li key={item.value} className={styles.item}>
            <label className={styles.label} aria-label={name}>
              <input
                type="checkbox"
                className={styles.checkbox}
                checked={item.isRefined}
                disabled={item.count === 0}
                onChange={(e) => {
                  e.preventDefault();
                  refine(item.value);
                }}
              />
              <span
                aria-hidden="true"
                className={cn(styles.swatch, swatchStyles.button, {
                  [swatchStyles.buttonSelected]: item.isRefined,
                  [swatchStyles.buttonNoData]: isNoData,
                })}
              >
                <span
                  className={swatchStyles.inner}
                  style={{
                    backgroundColor: isNoData ? 'var(--color-white)' : fill,
                  }}
                />
              </span>
              <span className={styles.labelText}>{name}</span>
              <span className={styles.count}>{formatNumber(item.count)}</span>
            </label>
          </li>
        );
      })}
    </ul>
  );
};

export default ColourRefinement;
